module.exports = __webpack_public_path__ + "img/agent-skill.bca72dd0.png";